import { BannerAdService } from '../../shared/banner-ad.service';
import { DatagridService } from '../../../shared/widgets/datagrid/datagrid.service';
import { BannerDto } from '../../shared/dto/banner.dto';
import { BannerSearchDto } from '../../shared/dto/banner-search.dto';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PagedResultGeneric, TranslationService, NotificationService } from 'src/app/shared';
import { MenuItem, SelectItem, ConfirmationService } from 'primeng/api';
import { BannerAdEditDialogComponent } from '../../banner-ad-edit-dialog/banner-ad-edit-dialog.component';

@Component({
  selector: 'wl-banner-ad-search-grid',
  templateUrl: './banner-ad-search-grid.component.html',
  styleUrls: ['./banner-ad-search-grid.component.less'],
    standalone: false
})
export class BannerAdSearchGridComponent extends LazySelectableTableComponent<BannerSearchDto, BannerDto> implements OnInit {
  @ViewChild(BannerAdEditDialogComponent) bannerAdEditDialogComponent: BannerAdEditDialogComponent;
  private _rowMenuItems = new Map<number, MenuItem[]>();
  public pagingSizeItems: SelectItem[];

  constructor(
    datagridService: DatagridService,
    private _bannerAdService: BannerAdService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
    private _confirmationService: ConfirmationService
  ) {
    super('BannerId', datagridService);
  }

  fetchResults(): Promise<PagedResultGeneric<BannerDto>> {
    return this._bannerAdService.search(this.searchParams);
  }

  async ngOnInit(): Promise<void> {
    this.pagingSizeItems = [
      {
        label: await this._translationService.getTitlecase('common.page-size.show-20'),
        value: 20,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-100'),
        value: 100,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-all'),
        value: 9999,
      },
    ];
  }

  clear() {
    this.searchParams = new BannerSearchDto();
    this.search();
  }

  actionItemsForBanner(banner: BannerDto) {
    if (!this._rowMenuItems.has(banner.BannerId)) {
      this._rowMenuItems.set(banner.BannerId, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editBanner(banner),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deleteBanner(banner),
        },
      ]);
    }
    return this._rowMenuItems.get(banner.BannerId);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  private editBanner(banner: BannerDto) {
    this.bannerAdEditDialogComponent.open(banner.BannerId);
  }

  private deleteBanner(banner: BannerDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('banner-ads.search.confirm-delete-message'),
      key: 'deleteBannerAdCD',
      accept: () => {
        this.loading = true;
        this._bannerAdService
          .delete(banner.BannerId)
          .then(() => {
            this._notificationService.translateSuccess('banner-ads.search.banner-deleted-message');
            this.search();
          })
          .catch((error) => {
            this._notificationService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
